'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box from '../../kit/box'
import Pressable, { PressableProps } from '../../kit/pressable'
import Text from '../../kit/text'

// lib
import { ThemeColor, useHover } from '../_support'

/* -----------------------------------------------------------------------------
 * StatCard
 * -------------------------------------------------------------------------- */

export type StatCardProps = PressableProps & {
  count: React.ReactNode
  dotColor?: ThemeColor
  label: string
  selected?: boolean
}

function StatCard({
  count,
  dotColor,
  label,
  selected = false,
  ...otherProps
}: StatCardProps) {
  const { hoverProps, isHovered } = useHover()

  return (
    <Pressable
      bg='proSurface'
      borderColor={selected ? 'proAccent' : 'proBorder'}
      borderRadius='proLg'
      borderStyle='solid'
      borderWidth={1}
      boxShadow='proCard'
      px='16'
      py='16'
      style={{ transform: [{ translateY: isHovered ? -2 : 0 }] } as any}
      {...hoverProps}
      {...otherProps}
    >
      <Text font='pro.display.25.bold' textColor='proInk'>
        {count}
      </Text>
      <Box alignItems='center' flexDirection='row' gap='08' mt='08'>
        {dotColor ? (
          <Box
            bg={dotColor}
            borderRadius='proPill'
            flex='0 0 auto'
            height={8}
            width={8}
          />
        ) : null}
        <Text font='pro.label.11' textColor='proTextMuted'>
          {label}
        </Text>
      </Box>
    </Pressable>
  )
}

export default StatCard
